<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Time Settings</h4>
        <el-form :model="From"
            ref="From" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :rules="formCheck"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Current Time :" >
               <el-date-picker :editable="false" 
               format="yyyy-MM-dd HH:mm:ss"
               value-format="yyyy-MM-dd HH:mm:ss"
               size="mini" v-model="value1" type="datetime" placeholder="Select date time" style="width: 100%">
                </el-date-picker>
            </el-form-item>

             <el-form-item label="Time Zone Select:" prop="selection">
                <el-select v-model="From.selection" placeholder="Please select" style="width: 100%">
                    <el-option v-for="item in selectionLists" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            
             <el-form-item   label="Automatically Adjust for Daylight Saving:" prop="">
                 <el-switch v-model="From.daylight" ></el-switch>
            </el-form-item>

             <el-form-item label="Enable NTP client Update:" prop="">
                 <el-switch v-model="From.ntpEnabled" ></el-switch>
            </el-form-item>

            <el-form-item label="NTP server1:" prop="server1">
                <el-input v-model="From.server1" :disabled="!From.ntpEnabled"></el-input>
            </el-form-item>
             <el-form-item label="NTP server2:" prop="server2">
                <el-input v-model="From.server2" :disabled="!From.ntpEnabled"></el-input>
            </el-form-item>
             <el-form-item label="NTP server3:" prop="server3">
                <el-input v-model="From.server3" :disabled="!From.ntpEnabled"></el-input>
            </el-form-item>
             <el-form-item label="NTP server4:" prop="server4">
                <el-input v-model="From.server4" :disabled="!From.ntpEnabled"></el-input>
            </el-form-item>
             <el-form-item label="NTP server5:" prop="server5">
                <el-input v-model="From.server5" :disabled="!From.ntpEnabled"></el-input>
            </el-form-item>
             <el-form-item label="Interval:" prop="interval">
                <el-input v-model="From.interval" :disabled="!From.ntpEnabled"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
                <el-button type="primary" @click="getData">Refresh</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import ntp_zone_array from "../../plugins/time.js";
export default {
  data() {
    return {
      loading: false,
      year: "",
      month: "",
      day: "",
      hour: "",
      minute: "",
      second: "",
      value1:"",
      From: {
        selection: "",
        daylight: false,
        ntpEnabled: false,
        server1: "",
        server2: "",
        server3: "",
        server4: "",
        server5: "",
        interval: ""
      },
      selectionLists: [],
      formCheck:{
          server1:[
              {
                  validator:(rule, value, callback) => {
                      if (value.indexOf("reboot") > -1) {
                        callback(new Error('Input Error! NTP server contain invalid string.'));
                      }else {
                        callback()
                      }
                  },
                  trigger: 'blur'
              }
          ],
          server2:[
              {
                  validator:(rule, value, callback) => {
                      if (value.indexOf("reboot") > -1) {
                        callback(new Error('Input Error! NTP server contain invalid string.'));
                      }else {
                        callback()
                      }
                  },
                  trigger: 'blur'
              }
          ],
          server3:[
              {
                  validator:(rule, value, callback) => {
                      if (value.indexOf("reboot") > -1) {
                        callback(new Error('Input Error! NTP server contain invalid string.'));
                      }else {
                        callback()
                      }
                  },
                  trigger: 'blur'
              }
          ],
          server4:[
              {
                  validator:(rule, value, callback) => {
                      if (value.indexOf("reboot") > -1) {
                        callback(new Error('Input Error! NTP server contain invalid string.'));
                      }else {
                        callback()
                      }
                  },
                  trigger: 'blur'
              }
          ],
          server5:[
              {
                  validator:(rule, value, callback) => {
                      if (value.indexOf("reboot") > -1) {
                        callback(new Error('Input Error! NTP server contain invalid string.'));
                      }else {
                        callback()
                      }
                  },
                  trigger: 'blur'
              }
          ],
          interval:[
              {
                  validator:(rule, value, callback) => {
                      if (!validator.isInt(value + "", {min: 0, max: 2147483647})) {
                        callback(new Error('Input Error! Interval is an integer and range [0-2147483647].'));
                      }else {
                        callback()
                      }
                  },
                  trigger: 'blur'
              }
          ]
      }
    };
  },
  methods: {
    timeNow() {
      var date = new Date();
      this.year = String(date.getFullYear());
      this.month = String(date.getMonth() + 1);
      this.day = String(date.getDate());
      this.hour = String(date.getHours());
      this.minute = String(date.getMinutes());
      this.second = String(date.getSeconds());
    },
    init() {
      this.selectionLists = [];
      for (var i = 0; i < ntp_zone_array.length; i++) {
        this.selectionLists.push({
          label: ntp_zone_array[i].name,
          value: ntp_zone_array[i].value
        });
      }
      this.From.selection = ntp_zone_array[0].value;
    },
    getData() {
      this.loading = true;
      axios.post("/boafrm/getNtpStatus").then(res => {
        this.loading = false;
        let data = res.data;
    
        this.From.selection = data.ntpTimeZone;
        this.From.daylight = data.DaylightSave == 0 ? false : true;
        this.From.ntpEnabled = data.ntpEnabled == 0 ? false : true;
        this.From.server1 = data.ntpServerIp1;
        this.From.server2 = data.ntpServerIp2;
        this.From.server3 = data.ntpServerIp3;
        this.From.server4 = data.ntpServerIp4;
        this.From.server5 = data.ntpServerIp5;
        this.From.interval = data.ntpInterval;
        this.value1 = `${data.year}-${data.month}-${data.day} ${data.hour}:${data.minute}:${data.second}`
      });
    },
    setData() {
      let nowData = new Date(this.value1.replace(/-/g, "/"))
      let postData = {
        year: nowData.getFullYear(),
        month:nowData.getMonth()+1,
        day: nowData.getDate(),
        hour: nowData.getHours(),
        minute: nowData.getMinutes(),
        second: nowData.getSeconds(),
        timeZone: this.From.selection,
        dlenabled: this.From.daylight == true ? "ON" : "",
        enabled: this.From.ntpEnabled == true ? "ON" : "",
        ntpServerIp1: this.From.server1,
        ntpServerIp2: this.From.server2,
        ntpServerIp3: this.From.server3,
        ntpServerIp4: this.From.server4,
        ntpServerIp5: this.From.server5,
        ntpInterval: this.From.interval,
        "submit-url": "/ntp.htm",
        save: "Save"
      };

      this.loading = true;
      axios.post("/boafrm/setformNtp", postData).then(res => {
        this.loading = false;
          this.$message.success(res.data.msg);
        this.getData();
      });
    },
    save() {
      if(this.value1==null){
        this.$message.error("Please choose the time!");
        return
      }
      this.$refs['From'].validate((valid) => {
        if (valid) {
          this.setData();
        } 
      })
    }
  },
  created() {
    this.init();
    this.getData();
  }
};
</script>
<style lang="scss" >
.fhv-centent {
  .change {
    &.time {
      margin-bottom: 0px;
      width: auto;
      label {
        width: 40px;
        padding: 0 5px;
        text-align: center;
      }
      .el-input__inner {
        width: 45px;
        padding: 5px;
        height: 30px;
      }
    }
  }
}
</style>



